<template>
    <div v-if="loaded">
        <div class="viewport">
            <md-toolbar :md-elevation="1">
                <span class="md-title">Product</span>
            </md-toolbar>
            <md-list class="md-triple-line" v-if="!this.upsertInventory.inventory_id">
                <product-search-modal
                    @set-selected-product="setSelectedProduct($event)"
                    style="padding-left: 15px; z-index: 1000; width: 95%"
                >
                </product-search-modal>
            </md-list>
            <md-list class="md-triple-line" v-if="this.upsertInventory.inventory_id">
                <div>
                    <label style="padding-left: 15px; z-index: 1000; width: 95%">
                        {{
                            this.upsertInventory.product.name + ' (' + this.upsertInventory.product.product_number + ')'
                        }}
                    </label>
                </div>
            </md-list>
        </div>

        <div class="viewport">
            <md-toolbar :md-elevation="1">
                <span class="md-title">Locatie</span>
            </md-toolbar>
            <md-list class="md-triple-line" v-if="!this.upsertInventory.inventory_id">
                <location-search-modal
                    @set-selected-location="setSelectedLocation($event)"
                    style="padding-left: 15px; z-index: 1000; width: 95%"
                >
                </location-search-modal>
            </md-list>
            <md-list class="md-triple-line" v-if="this.upsertInventory.inventory_id">
                <div>
                    <label style="padding-left: 15px; z-index: 1000; width: 95%">
                        {{
                            this.upsertInventory.location
                                ? this.upsertInventory.location.location_name +
                                  ' (' +
                                  this.upsertInventory.location_id +
                                  ')'
                                : 'Geen locatie'
                        }}
                    </label>
                </div>
            </md-list>
        </div>

        <div class="viewport">
            <md-toolbar :md-elevation="1">
                <span class="md-title"
                    >Aantal
                    {{
                        inventoryStore.state.selectedProduct
                            ? '(' +
                              inventoryStore.state.selectedProduct.pricing.unit_amount +
                              ' ' +
                              inventoryStore.state.selectedProduct.pricing.unit_type +
                              ')'
                            : ''
                    }}</span
                >
            </md-toolbar>
            <md-list class="md-triple-line">
                <div class="md-layout-item" style="padding-left: 15px; z-index: 1000; width: 95%">
                    <md-field>
                        <label
                            >Aantal
                            {{
                                this.inventoryId
                                    ? '(' +
                                      this.upsertInventory.product.pricing.unit_amount +
                                      ' ' +
                                      this.upsertInventory.product.pricing.unit_type +
                                      ')'
                                    : ''
                            }}
                            <!--                            {{-->
                            <!--                                upsertInventory.product-->
                            <!--                                    ? '(' +-->
                            <!--                                      upsertInventory.product.pricing.unit_amount +-->
                            <!--                                      ' ' +-->
                            <!--                                      upsertInventory.product.pricing.unit_type +-->
                            <!--                                      ')'-->
                            <!--                                    : ''-->
                            <!--                            }}-->
                        </label>
                        <md-input
                            type="number"
                            name="quantity"
                            id="quantity"
                            v-model="upsertInventory.quantity_on_hand"
                        ></md-input>
                    </md-field>
                </div>
            </md-list>
        </div>
        <md-button @click="upsertInventoryFunction()" style="margin-left: 0; width: 100%" class="md-raised md-primary"
            >Save
        </md-button>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import router from '@/router';
import ProductSearchModal from '@/components/product-search-modal/ProductSearchModal.vue';
import * as toastr from 'toastr';
import { appStore } from '@/store';
import { IInventoryEntity, IInventoryExtendedEntity, ILocationsEntity } from '@phrospr/lib-models';
import { ILocationSearchEntity, InventoryApi, IProductEntity } from '@phrospr/api-backend';
import InventoryProduct from '@/views/inventory/components/InventoryProduct.vue';
import LocationSearchModal from '@/components/location-search-modal/LocationSearchModal.vue';
import { inventoryStore } from '@/store/inventory/inventory.store';

@Component({
    computed: {
        inventoryStore() {
            return inventoryStore;
        },
    },
    components: {
        LocationSearchModal,
        InventoryProduct,
        ProductSearchModal,
    },
    data() {
        return {
            code: '',
            scanning: false,
        };
    },
})
export default class InventoryUpsert extends Vue {
    loaded = false;
    remarks: string = null;

    upsertInventory: IInventoryExtendedEntity;

    selectedProduct: IProductEntity;

    @Prop() inventoryId?: number;

    constructor() {
        super();
        this.loaded = false;
        this.load();
    }

    private async load() {
        await inventoryStore.dispatch('startInventoryUpsert', this.inventoryId);
        this.upsertInventory = inventoryStore.state.upsertInventory;
        if (this.inventoryId === undefined) {
            if (appStore.state.inventoryCreateSettings) {
                const { product, location } = appStore.state.inventoryCreateSettings;
                this.upsertInventory.product_id = product.product_id;
                this.upsertInventory.location_id = location.location_id;
                inventoryStore.commit('setSelectedProduct', product);
                inventoryStore.commit('setSelectedLocation', location);
            } else {
                inventoryStore.commit('setSelectedProduct', null);
                inventoryStore.commit('setSelectedLocation', null);
            }
        }
        this.loaded = true;
    }

    public async upsertInventoryFunction() {
        if (this.upsertInventory.product_id === null) {
            toastr.error('Geen product  geselecteerd');
            return;
        }
        if (this.upsertInventory.quantity_on_hand < 0 || this.upsertInventory.quantity_on_hand === null) {
            toastr.error('Geen aantal ingegeven');
            return;
        }

        try {
            await InventoryApi.upsertInventory({
                inventory_id: this.upsertInventory.inventory_id,
                product_id: this.upsertInventory.product_id,
                location_id: this.upsertInventory.location_id,
                quantity_on_hand: this.upsertInventory.quantity_on_hand,
                data: this.upsertInventory.data,
            });
            await router.push({ path: `/inventory/overview` });
        } catch (e) {
            toastr.error(
                'Fout bij het toevoegen van stock. De locatie bestaat. Ga naar het bestaande record en pas daar de stock aan.',
            );
        }
    }

    setSelectedProduct(product: IProductEntity) {
        inventoryStore.commit('setSelectedProduct', product);
        this.upsertInventory.product_id = product.product_id;
    }

    setSelectedLocation(location: ILocationsEntity) {
        inventoryStore.commit('setSelectedLocation', location);
        this.upsertInventory.location_id = location.location_id;
    }
}
</script>

<style lang="scss" scoped>
.viewport {
    max-width: 100%;
    vertical-align: top;
    overflow: auto;
    border: 1px solid rgba(#000, 0.12);
    display: inherit;
    width: -webkit-fill-available;
}
</style>
